import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { ViewBreakpoint } from '../../models/view-breakpoint.enum';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { takeUntil, filter } from 'rxjs/operators';
import { AnimationService } from 'src/app/engine/animation.service';
import { ViewService } from '../../view.service';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';

@Component({
  selector: 'app-view-navbar',
  templateUrl: './view-navbar.component.html',
  styleUrls: ['./view-navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewNavbarComponent implements OnInit, OnDestroy {
  // ---------- Observables ----------
  @Select(ViewState.getBreakpoint)
  breakpoint$: Observable<ViewBreakpoint>;

  @Select(StoryChaptersState.getSelectedChapter)
  chapter$: Observable<ChapterModel>;

  @Select(StoryChaptersState.getSelectedChapterIndex)
  chapterIndex$: Observable<number>;

  @Select(StoryChaptersState.getChapterCount)
  chapterCount$: Observable<number>;


  // ---------- Class Variables ----------
  viewBreakpoint = ViewBreakpoint;
  isAnimated = false;
  isPaginated = false;
  showScrubber = false;
  ngUnsubscribe = new Subject();
  viewLayout = ViewLayout;
  nextChapterLabel = '';
  previousChapterLabel = '';
  
  
  // ---------- Lifecycle Events ----------
  constructor(
    private animationService: AnimationService,
    private viewService: ViewService,
    private changeDetectorRef: ChangeDetectorRef,
    private layoutService: LayoutService
  ) { }

  ngOnInit() {

    
    this.chapter$.pipe(
      filter(chapter => chapter != null),
      takeUntil(this.ngUnsubscribe)
    ).subscribe(chapter => {
      this.isAnimated = this.animationService.isChapterAnimated(chapter);
      this.changeDetectorRef.markForCheck();
    });

    this.chapterCount$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(count => {
      this.isPaginated = count > 1;
      this.changeDetectorRef.markForCheck();
    });

    this.breakpoint$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(breakpoint => {
      this.showScrubber = breakpoint !== ViewBreakpoint.Small;
      this.changeDetectorRef.markForCheck();
    });

    combineLatest(
      this.chapterIndex$,
      this.chapterCount$
    ).pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(([index, count]) => {
      const previous = index > 0 ? index : 1;
      const next = index + 2 > count ? count : index + 2;

      this.nextChapterLabel = `Next Chapter (${next} of ${count})`;
      this.previousChapterLabel = `Previous Chapter (${previous} of ${count})`;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  // ---------- Interactions ----------
  handleNextChapter() {
    this.viewService.nextChapter();
  }

  handlePreviousChapter() {
    this.viewService.previousChapter();
  }

  isVisible(layout: ViewLayout) {
    return this.layoutService.isLayoutVisible(layout);
  }
}
